/* eslint-disable no-unused-vars */
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { _delete, _get, _patch, _post, _put } from "../../Services/baseApi";
import { errorHandler, successToast } from "../../Utils/toast";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import {
  ZONE_ADD_URL,
  ZONE_EXPORT_URL,
  ZONE_IMPORT_URL,
  ZONE_LIST_URL,
  ZONE_SAMPLE_URL,
  ZONE_DELETE_URL,
  ZONE_UPDATE_URL,
} from "../../Services/endpoints";
import { createMasterImportThunks } from "../../Utils/createMasterImportThunks";

const initialState = {
  isLoading: false,
  zonesList: {
    findZones: [],
    limit: 0,
    page: 0,
    totalCount: 0,
  },
};

const zonesSlice = createSlice({
  name: "zones",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getZonesThunk.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getZonesThunk.fulfilled, (state, action) => {
        state.isLoading = false;
        state.zonesList = action.payload;
      })
      .addCase(getZonesThunk.rejected, (state) => {
        state.isLoading = false;
      });

    builder
      .addCase(addZonesThunk.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(addZonesThunk.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(addZonesThunk.rejected, (state) => {
        state.isLoading = false;
      });

    builder
      .addCase(updateZonesThunk.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateZonesThunk.fulfilled, (state, action) => {
        state.isLoading = false;
        // state.zonesList = action.payload;
      })
      .addCase(updateZonesThunk.rejected, (state) => {
        state.isLoading = false;
      });

    builder
      .addCase(deleteZonesThunk.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteZonesThunk.fulfilled, (state, action) => {
        state.isLoading = false;
        // state.zonesList = action.payload;
      })
      .addCase(deleteZonesThunk.rejected, (state) => {
        state.isLoading = false;
      });
  },
});

// export const {} = zonesSlice.actions;
// export default authSlice.reducer;

// Define the reducer export with persist data
export default persistReducer(
  {
    key: "zone/persist",
    storage,
    whitelist: [],
  },
  zonesSlice.reducer
);

export const getZonesThunk = createAsyncThunk(
  "zonesSlice/getZonesThunk",
  async (payload) => {
    try {
      const response = await _get(ZONE_LIST_URL, {
        page: payload?.page || undefined,
        limit: payload?.limit || undefined,
        name: payload?.name || undefined,
        key: payload?.key ? payload?.key : undefined,
        keyOrder:
          payload?.key && payload?.keyOrder ? payload?.keyOrder : undefined,
        agencyId: payload?.agencyId || undefined,
        stateId: payload?.stateId || undefined,
        cityId: payload?.cityId || undefined,
      });

      return response?.data.result;
    } catch (error) {
      errorHandler(error);
    }
  }
);

export const addZonesThunk = createAsyncThunk(
  "zonesSlice/addZonesThunk",
  async (payload) => {
    try {
      const response = await _post(ZONE_ADD_URL, {
        name: payload.name,
        cityId: payload.cityId,
      });
      payload.handleFun();
      successToast(response?.data?.message || "Zone Created Successfully");
      return response?.data?.result;
    } catch (error) {
      errorHandler(error);
    }
  }
);

export const updateZonesThunk = createAsyncThunk(
  "zonesSlice/updateZonesThunk",
  async (payload) => {
    try {
      const response = await _patch(ZONE_UPDATE_URL, {
        id: payload.id,
        name: payload.name,
        cityId: payload.cityId,
      });
      payload.handleFun();
      successToast(response?.data?.message || "Zone Updated Successfully");
      return response?.data?.data;
    } catch (error) {
      errorHandler(error);
    }
  }
);

const zoneImportThunks = createMasterImportThunks({
  exportType: "zonesSlice",
  exportUrl: ZONE_EXPORT_URL,
  importUrl: ZONE_IMPORT_URL,
  sampleUrl: ZONE_SAMPLE_URL,
  defaultExportFilename: "zones-export.xlsx",
  defaultSampleFilename: "zones-sample.xlsx",
  exportSuccessMessage: "Zones exported successfully",
});

export const exportZonesThunk = zoneImportThunks.exportThunk;
export const downloadZoneSampleThunk = zoneImportThunks.downloadSampleThunk;
export const importZonesThunk = zoneImportThunks.importThunk;

export const deleteZonesThunk = createAsyncThunk(
  "zonesSlice/deleteZonesThunk",
  async (payload) => {
    try {
      const response = await _delete(`${ZONE_DELETE_URL}/${payload?.id}`);
      payload.handleFun();
      successToast(response?.data?.message || "Zone Deleted Successfully");

      return response?.data?.data;
    } catch (error) {
      errorHandler(error);
    }
  }
);
